module.exports = __webpack_public_path__ + "static/rootbeer-556871849989ee7ecd529bdc724c9536.jpg";